import React from "react";
// also exported from '@storybook/react' if you can deal with breaking changes in 6.1
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { LinkFormControl } from "../Web/LinkFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { ButtonControlSize, LinkControlType, LinkControlUnderline } from "../../Utilities/FormDesignConstants";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col1 = new XColumnContainerColumn();
    let col2 = new XColumnContainerColumn();
    col2.interControlSpacing = 20;

    container.add(col1);
    container.add(col2);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Large";
    col1.add(label);

    let link = new LinkFormControl();
    link.label = "Link Label";
    link.valueName = "link";
    link.size = ButtonControlSize.LARGE;
    link.type = LinkControlType.ACTION;
    link.linkUnderline = LinkControlUnderline.HOVER;
    col1.add(link);

    link = new LinkFormControl();
    link.label = "Link Label";
    link.valueName = "link";
    link.size = ButtonControlSize.LARGE;
    link.type = LinkControlType.ACTION;
    link.linkUnderline = LinkControlUnderline.ALWAYS;
    col1.add(link);

    link = new LinkFormControl();
    link.label = "Link Label";
    link.valueName = "link";
    link.size = ButtonControlSize.LARGE;
    link.type = LinkControlType.ACTION;
    link.linkUnderline = LinkControlUnderline.NONE;
    col1.add(link);

    label = new LabelFormControl();
    label.text = "Small";
    col2.add(label);

    link = new LinkFormControl();
    link.label = "Link Label";
    link.valueName = "link";
    link.size = ButtonControlSize.SMALL;
    link.type = LinkControlType.ACTION;
    link.linkUnderline = LinkControlUnderline.HOVER;
    col2.add(link);

    link = new LinkFormControl();
    link.label = "Link Label";
    link.valueName = "link";
    link.size = ButtonControlSize.SMALL;
    link.type = LinkControlType.ACTION;
    link.linkUnderline = LinkControlUnderline.ALWAYS;
    col2.add(link);

    link = new LinkFormControl();
    link.label = "Link Label";
    link.valueName = "link";
    link.size = ButtonControlSize.SMALL;
    link.type = LinkControlType.ACTION;
    link.linkUnderline = LinkControlUnderline.NONE;
    col2.add(link);

    container = new XColumnContainer();
    col1 = new XColumnContainerColumn();
    col2 = new XColumnContainerColumn();
    col2.interControlSpacing = 20;

    container.add(col1);
    container.add(col2);
    ui.add(container);

    return { form: ui };
}

export const LinkStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Link",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                (c as LinkFormControl).type = LinkControlType.URL;
            }

            let data = new ExecutionData();
            data.values["link"] = "https://google.com";

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Link",
        "With Links",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                (c as LinkFormControl).type = LinkControlType.ACTION;
            }

            let data = new ExecutionData();
            data.values["link"] = "https://google.com";

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Link",
        "Action",
    ),
];
